<template>
  <article>
    <!--바로가기 navi-->
    <div id="accNav">
      <router-link to="#content">본문 바로가기</router-link>
      <router-link to="#footer">푸터 바로가기</router-link>
    </div>
    <!-- Web -->
    <header id="web">
      <div class="header-wrap">
        <div class="inner">
          <div class="header">
            <h1 class="header-main-logo">
              <router-link to="/main">
                <img
                  :src="require('@/assets/images/common/header-main-logo.png')"
                  alt="아산시주차포털 로고"
                />
              </router-link>
            </h1>
            <div class="searchBar">
              <input
                type="text"
                title="검색창 입력"
                placeholder="검색어를 입력하세요."
                v-model.trim="searchKeyword"
                @keyup.enter="searchAll"
              />
              <button type="button" class="searchBtn" @click="searchAll">
                <span class="hidden">검색</span>
              </button>
            </div>

            <div class="utilBtn" v-if="!isLogin">
              <ColorButton
                color="purple"
                :width="100"
                @click="$pushQueryString('/login')"
              >
                <template #title>로그인</template>
              </ColorButton>
              <ColorButton
                color="border"
                :width="135"
                @click="$pushQueryString('/signup/business/agreement')"
              >
                <template #title>사업자 회원가입</template>
              </ColorButton>
            </div>
            <div class="utilBtn" v-else>
              <div class="userInfo">
                <p>
                  <span class="name">{{ empNm }}</span
                  >님
                </p>
              </div>
              <ColorButton color="grayEA" :width="100" @click="logout">
                <template #title>로그아웃</template>
              </ColorButton>
            </div>
          </div>
        </div>
      </div>
      <div class="gnb-wrap">
        <nav class="gnb" @mouseover="openGnbHover" @mouseleave="closeGnbHover">
          <ul class="depth01">
            <div class="depth_bg" :class="{ isHover: isHover }" />
            <li v-for="(firDepth, index) in firDepthList" :key="index">
              <span>{{ firDepth.title }}</span>
              <ul class="depth02">
                <li v-for="(secDepth, index) in firDepth.menuList" :key="index">
                  <router-link :to="secDepth.link">
                    {{ secDepth.title }}
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </header>

    <!-- mobile -->
    <header id="mobile">
      <div class="header-wrap">
        <div class="header-title">
          <img
            :src="require('@/assets/images/common/header-main-logo.png')"
            alt="아산시주차포털 로고"
            class="header-main-logo"
            @click="$pushQueryString('/main')"
          />
          <button
            type="button"
            class="menuButton"
            @click="openMobileMenu"
            v-if="!isMenuShow"
          >
            <span class="hidden">메뉴</span>
          </button>
          <button
            type="button"
            class="closeMenu"
            @click="closeMobileMenu"
            v-if="isMenuShow"
          >
            <span class="hidden">메뉴 닫기</span>
          </button>
        </div>
        <div class="searchBar" v-if="!isMenuShow">
          <input
            type="text"
            title="검색창 입력"
            placeholder="검색어를 입력하세요."
            v-model="searchKeyword"
            @keyup.enter="searchAll"
          />
          <button type="button" class="searchBtn" @click="searchAll">
            <span class="hidden">검색</span>
          </button>
        </div>
        <div class="utilBtn-area" v-else>
          <div class="utilBtn" v-if="!isLogin">
            <ColorButton
              color="purple"
              :width="80"
              :height="34"
              :fontSize="14"
              @click="$pushQueryString('/login')"
            >
              <template #title>로그인</template>
            </ColorButton>
            <ColorButton
              color="border"
              :width="124"
              :height="34"
              :fontSize="14"
              @click="$pushQueryString('/signup/business/agreement')"
            >
              <template #title>사업자 회원가입</template>
            </ColorButton>
          </div>
          <div class="utilBtn" v-else>
            <div class="userInfo">
              <p>
                <span class="name"> {{ empNm }} </span>님
              </p>
            </div>
            <ColorButton
              color="grayEA"
              :width="80"
              :height="34"
              :fontSize="14"
              @click="logout"
            >
              <template #title>로그아웃</template>
            </ColorButton>
          </div>
        </div>
      </div>
      <nav class="gnbMobile" v-show="isMenuShow">
        <v-expansion-panels variant="accordion" v-model="activePanels">
          <v-expansion-panel
            v-for="(firDepth, index) in firDepthList"
            :key="index"
          >
            <v-expansion-panel-title>
              {{ firDepth.title }}
              <template #actions="{ expanded }">
                <i :class="expanded ? 'menu-on' : 'menu-off'" />
              </template>
            </v-expansion-panel-title>
            <v-expansion-panel-text
              v-for="(secDepth, index) in firDepth.menuList"
              :key="index"
              @click="$pushQueryString(secDepth.link)"
            >
              <a>
                {{ secDepth.title }}
              </a>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </nav>
    </header>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep, isEmpty } from 'lodash';
import api from '@/api/modules/util';
import { openModal } from '@/util/modalSetter';
import ColorButton from '@/components/button/ColorButton.vue';
import menuJson from '@/store/menuJson.json';

export default {
  components: {
    ColorButton,
  },

  data() {
    return {
      firDepthList: [],
      searchKeyword: '',

      activePanels: null,

      isMenuShow: false,
      isHover: false,
    };
  },

  computed: {
    ...mapGetters({
      menuList: 'getMenuList',
    }),

    isLogin() {
      return this.$store.state.userStore.isLogin;
    },

    empNm() {
      return this.$store.state.userStore.empNm;
    },
  },

  watch: {
    $route() {
      this.isMenuShow = false;
      this.activePanels = null;
    },
  },

  created() {
    this.getGnbMenuList();
  },

  methods: {
    getGnbMenuList() {
      if (this.menuList) {
        const copy = cloneDeep(this.menuList);

        this.firDepthList = copy.filter(menu => {
          if (isEmpty(menu.menuList)) {
            menu = null;
          }

          return menu;
        });
      }
    },

    openGnbHover() {
      this.isHover = true;
    },

    closeGnbHover() {
      this.isHover = false;
    },

    openMobileMenu() {
      this.isMenuShow = true;
    },

    closeMobileMenu() {
      this.isMenuShow = false;
    },

    searchAll() {
      if (!this.searchKeyword) return;

      this.$pushQueryString('/searchlist', { q: this.searchKeyword });
    },

    async logout() {
      const res = await api.logout();

      if (!res) {
        openModal(
          '시스템 오류가 발생하였습니다.\n관리자에게 문의해주세요.',
          'warning',
        );
        return;
      }

      await this.$store.dispatch('authMenuList', menuJson.menuList);

      this.getGnbMenuList();
      this.$store.dispatch('logout');

      openModal('안전하게 로그아웃 되었습니다.', 'check', '/main');
    },
  },
};
</script>
